import React, { useState } from "react";
import { Filter } from "lucide-react";
import { useTranslation } from "react-i18next";
 
import { setToggleFilter } from "../../redux/ToggleSlice";
import { useDispatch, useSelector } from "react-redux";


const FilterHeader = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const toggleFilter = useSelector((state) => state.toggler.toggleFilter);
  const [test, setTest] = useState(false);
  const [filter, setFilter] = useState(t("MostPopular"));
  
  const toggleFilterAside = () => {
    dispatch(setToggleFilter());
    setTest(!test);
  };
  const { myBookList, openFilter } = props;

  const filterDropdown = [t("MostPopular"), t("BestSelling"), t("MostViewed")];
  return (
    <div className="d-flex justify-content-between">
      <div>
      {t("Showing")} <span className="fw-bold"> {myBookList?.length ? myBookList?.length : '4'}</span> {t("results")} 
        
      </div>
      <div className="d-flex align-items-center gap-3">
        <Filter
          className="cursor-pointer filterIcon block d-md-none"
          onClick={openFilter}
        />

        <div className="form-group d-flex align-items-center gap-1">
          <div class="dropdown">
            <button
              class="dropdown-toggle filterDropdown"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {filter}
            </button>
            <ul
              class="dropdown-menu px-2"
              aria-labelledby="dropdownMenuButton1"
            >
              {filterDropdown.map((filter, index) => (
                <li
                  className="dropdown-item cursor-pointer d-flex justify-content-between py-2 px-2 align-items-center chatFilterDropdownLists"
                  key={index}
                  onClick={() => setFilter(filter)}
                >
                  {filter}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div
          className={`px-1 py-1 d-flex justify-content-center align-items-center text-white rounded cursor-pointer ${
            toggleFilter ? "bgMain " : "bgInActive"
          }`}
          onClick={toggleFilterAside}
        >
          <Filter className={`${!toggleFilter && "fg-main"}`} />
        </div>
      </div>
    </div>
  );
};
export default FilterHeader;
